import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Col, message, Row, Tabs, Space } from 'antd';
import { CSVLink } from 'react-csv';

import { postIniciarAtendimentoExterno } from '../../services';

import iconBaixarCsv from '../../assets/icons/iconCsvBaixar.svg';
import Bloco from '../../components/Bloco';
import { CaledarioFaixa } from '../../components/CaledarioFaixa';
import { TableCustom } from './TableCustom';

import colors from '../../styles/colors';
import * as S from './styles';

const { TabPane } = Tabs;

export function PainelControleExterno() {
  const history = useHistory();
  const [ranger, setRanger] = useState({ from: null, to: null });
  const [headers, setHeaders] = useState([]);
  const [dataCSV, setDataCSV] = useState([]);
  const [loadingInitAtendimento, setLoadingInitAtendimento] = useState(false);
  const enable = !(ranger?.from && ranger?.to);
  const disableRelatorio = false;

  const csvConsultas = {
    filename: 'Consultas.csv',
    headers,
    data: dataCSV,
  };

  const iniciarAtendimento = async () => {
    setLoadingInitAtendimento(true);
    const { data, error } = await postIniciarAtendimentoExterno();

    if (data) {
      setLoadingInitAtendimento(false);
      return history.push('/atendimento');
    }

    if (error) {
      setLoadingInitAtendimento(false);
      return message.error('Não foi possível iniciar um atendimento');
    }
  };

  return (
    <S.Wrapper>
      <Col style={{ paddingBottom: '22px' }}>
        <Bloco>
          <Row justify="space-between" align="middle">
            <S.Title color={colors.greyText} size={18}>
              Para
              <span> iniciar uma consulta </span>
              clique no botão ao lado
            </S.Title>
            <S.ButtonIniciarAtendimento
              onClick={iniciarAtendimento}
              loading={loadingInitAtendimento}
            >
              Iniciar consulta
            </S.ButtonIniciarAtendimento>
          </Row>
        </Bloco>
      </Col>
      {disableRelatorio && (
        <Col style={{ margin: '15px 0' }}>
          <S.BlocoCustonRealtorio>
            <Row justify="space-between" align="middle">
              <Col xs={{ span: 5, offset: 0 }} lg={{ span: 6, offset: 0 }}>
                <Row>
                  <S.Title
                    color={colors.blue}
                    size={28}
                    weight="true"
                    line={33}
                  >
                    Relatórios
                  </S.Title>
                </Row>
              </Col>
              <Col xs={{ span: 11, offset: 0 }} lg={{ span: 6, offset: 0 }}>
                <Row align="middle" justify="center">
                  <CaledarioFaixa change={setRanger} title="Período" />
                </Row>
              </Col>
              <Col xs={{ span: 5, offset: 0 }} lg={{ span: 6, offset: 0 }}>
                <Row align="middle" justify="end">
                  <CSVLink {...csvConsultas}>
                    <S.ButtonCsv
                      disabled={enable}
                      background={enable && '#E0E0E0'}
                    >
                      <Space>
                        <img src={iconBaixarCsv} alt="csv" />
                        Baixar CSV
                      </Space>
                    </S.ButtonCsv>
                  </CSVLink>
                </Row>
              </Col>
            </Row>
          </S.BlocoCustonRealtorio>
        </Col>
      )}
      <Col>
        <S.CardTabs height="72vh">
          <Tabs type="card">
            <TabPane
              key="1"
              tab="Solicitações"
              style={{
                paddingBottom: 16,
                borderRadius: 4,
                backgroundColor: '#fff',
              }}
            >
              <TableCustom
                dateRange={ranger}
                setHeaders={setHeaders}
                setDataCSV={setDataCSV}
              />
            </TabPane>
          </Tabs>
        </S.CardTabs>
      </Col>
    </S.Wrapper>
  );
}
